export default __webpack_public_path__ + "static/0093-617f8cc02b0426ec34cfdd9e1600b301.png";